import React from 'react';
import cx from 'classnames';

import TourStep from '../TourStep';
import { TourStepEnum } from 'features/onboarding/enums';

import styles from './TourCompletedModal.module.less';

const ProgressIcon = () => (
  <div className={styles.tourProgress}>
    <div className={styles.progressItem}>
      <div className={cx(styles.progressBg, styles.progressBgT)} />
    </div>

    <div className={styles.progressItem}>
      <div className={cx(styles.progressBg, styles.progressBgS)} />
    </div>

    <div className={styles.progressItem}>
      <div className={cx(styles.progressBg, styles.progressBgF)} />
    </div>
  </div>
);

export default function TourCompletedModal() {
  return (
    <TourStep
      isLastStep
      stepType={TourStepEnum.Congratulations}
      className={styles.congratulationStep}
      icon={<ProgressIcon />}
      title="Congratulations!"
      description={
        <>
          <div>You are well on your way to dominate this industry!</div>
          <div>
            Thanks for taking the tour.
          </div>
        </>
      }
    />
  );
}
